import {useState, useEffect} from "react";
import { useUserData } from "./useUserData";

export const usePermission = (permission: string) =>{
    const {permissions} = useUserData()
    const [permissionList, setPermissionList] = useState<string[] | null>(null)
    useEffect(() => {
        if (permissions !== undefined && permissions !== null) {
          let result = permissions.find(({ name }) => name === permission);
          // BUG PREEXISTENTE, no se corrige acá: si el grupo pedido no está entre los
          // permisos del usuario, `find` devuelve undefined y esta línea lanza. El `!`
          // conserva ese comportamiento tal cual; un `?.` lo cambiaría en silencio.
          // Queda anotado para un commit de fix aislado.
          setPermissionList(result!.permissions);
        }
    }, [permissions]);

    return{
        permissionList
    }
}
